var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "nav-menu bankari-dock",
    attrs: {
      "role": "navigation",
      "aria-label": "Hlavná navigácia"
    }
  }, [_c('div', {
    staticClass: "left-top-bar"
  }, [_c('div', {
    staticClass: "nav-link-block"
  }, [_c('user-profile')], 1), _c('div', {
    staticClass: "nav-link-block"
  }, [_c('button', {
    staticClass: "nav-link noselect link-icon-text",
    "class": [this.current === 'klienti' ? 'current' : ''],
    attrs: {
      "type": "button",
      "title": "Klienti"
    },
    on: {
      "click": function click($event) {
        return _vm.navigateTo('klienti');
      }
    }
  }, [_c('app-icon', {
    staticClass: "nav-link-icon",
    attrs: {
      "name": "users",
      "size": 25
    }
  }), _vm._v(" klienti ")], 1)]), _c('div', {
    staticClass: "nav-link-block"
  }, [_c('button', {
    staticClass: "nav-link noselect link-icon-text",
    "class": [this.current === 'hypoteky' ? 'current' : ''],
    attrs: {
      "type": "button",
      "title": "Hypotéky"
    },
    on: {
      "click": function click($event) {
        return _vm.navigateTo('hypoteky');
      }
    }
  }, [_c('app-icon', {
    staticClass: "nav-link-icon",
    attrs: {
      "name": "briefcase",
      "size": 25
    }
  }), _vm._v(" hypotéky ")], 1)]), _c('div', {
    staticClass: "nav-link-block"
  }, [_c('button', {
    staticClass: "nav-link noselect link-icon-text",
    "class": [this.current === 'servis' ? 'current' : ''],
    attrs: {
      "type": "button",
      "title": "Servis"
    },
    on: {
      "click": function click($event) {
        return _vm.navigateTo('servis');
      }
    }
  }, [_c('app-icon', {
    staticClass: "nav-link-icon",
    attrs: {
      "name": "clock",
      "size": 25
    }
  }), _vm._v(" servis ")], 1)]), _c('div', {
    staticClass: "nav-link-block"
  }, [_c('button', {
    staticClass: "nav-link noselect link-icon-text",
    attrs: {
      "type": "button",
      "title": "Kalendár"
    },
    on: {
      "click": function click($event) {
        return _vm.showCalendar();
      }
    }
  }, [_c('app-icon', {
    staticClass: "nav-link-icon",
    attrs: {
      "name": "calendar",
      "size": 24
    }
  }), _vm._v(" kalendár ")], 1)]), _c('div', {
    staticClass: "nav-link-block"
  }, [_c('button', {
    staticClass: "nav-link noselect link-icon-text",
    "class": [this.current === 'posudky' ? 'bl-color' : ''],
    attrs: {
      "type": "button",
      "title": "Metodika"
    },
    on: {
      "click": _vm.openKnowHowPopUp
    }
  }, [_c('app-icon', {
    staticClass: "nav-link-icon",
    attrs: {
      "name": "book",
      "size": 25
    }
  }), _vm._v(" metodika ")], 1)]), _vm.role === 'alex_admin' ? _c('div', {
    staticClass: "nav-link-block"
  }, [_c('button', {
    staticClass: "nav-link noselect link-icon-text",
    "class": {
      current: _vm.current === 'marketing'
    },
    attrs: {
      "type": "button",
      "title": "Marketing"
    },
    on: {
      "click": function click($event) {
        return _vm.navigateTo('marketing');
      }
    }
  }, [_c('app-icon', {
    staticClass: "nav-link-icon",
    attrs: {
      "name": "megaphone",
      "size": 25
    }
  }), _vm._v(" marketing ")], 1)]) : _vm._e(), _vm.role === 'alex_admin' ? _c('div', {
    staticClass: "nav-link-block"
  }, [_c('button', {
    staticClass: "nav-link noselect link-icon-text",
    "class": [this.current === 'nastavenia' ? 'current' : ''],
    attrs: {
      "type": "button",
      "title": "Nastavenia"
    },
    on: {
      "click": function click($event) {
        return _vm.navigateTo('nastavenia');
      }
    }
  }, [_c('app-icon', {
    staticClass: "nav-link-icon",
    attrs: {
      "name": "settings",
      "size": 25
    }
  }), _vm._v(" nastavenia ")], 1)]) : _vm._e()]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.embeddedWorkspace,
      expression: "!embeddedWorkspace"
    }],
    staticClass: "right-top-bar"
  }, [_c('button', {
    staticClass: "feedback-nav-button",
    "class": {
      'feedback-nav-button--unseen': _vm.hasUnseenUpdates
    },
    attrs: {
      "type": "button",
      "title": _vm.hasUnseenUpdates ? 'Máte novinku v aplikácii' : 'Novinky v aplikácii a spätná väzba',
      "aria-label": _vm.hasUnseenUpdates ? 'Otvoriť novú aktualizáciu aplikácie' : 'Otvoriť novinky v aplikácii a spätnú väzbu'
    },
    on: {
      "click": _vm.openUpdatesCenter
    }
  }, [_c('app-icon', {
    attrs: {
      "name": _vm.hasUnseenUpdates ? 'bell' : 'info',
      "size": 23
    }
  }), _vm.hasUnseenUpdates ? _c('span', {
    staticClass: "updates-unseen-badge",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("1")]) : _vm._e()], 1), _c('notification-handler', {
    ref: "notifications",
    attrs: {
      "rules": ['single']
    }
  })], 1), _c('audio', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "new-notification",
      "muted": "muted"
    }
  }, [_c('source', {
    attrs: {
      "src": require('@/sounds/new_message.mp3'),
      "type": "audio/mpeg"
    }
  })])]);

}
var staticRenderFns = []

export { render, staticRenderFns }